import { TrialExpiredRoute } from './-route-wrappers';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/trial-expired/journeys')({
  component: TrialExpiredRoute,
});
